import { useEffect, useState } from "react";
import { Box, Stack } from "@mui/material";
import { Custom } from "components";
import { useTheme } from "contexts";

// icons
import { AddRounded, RemoveRounded } from "@mui/icons-material";

type Props = {
  min?: number;
  value?: number;
  onChange: (value: number) => void;
};

export const Counter = ({ min = 0, value = 0, onChange }: Props) => {
  const { theme } = useTheme();

  const [count, setCount] = useState<number>(Math.max(min, value));

  useEffect(() => {
    if (value > min) setCount(value);
  }, [value]);

  const handleDecrement = () => {
    if (count > min) {
      setCount(count - 1);
      onChange(count - 1);
    }
  };

  const handleIncrement = () => {
    setCount(count + 1);
    onChange(count + 1);
  };

  const buttonSx = {
    color: theme.color.accent.color,
    backgroundColor: theme.color.accent.textAccent,
    "&:hover": {
      color: theme.color.accent.color,
      backgroundColor: theme.color.accent.textAccent,
    },
  };

  return (
    <Box
      borderRadius={theme.border.circle}
      bgcolor={theme.color.secondary.color}
    >
      <Stack direction="row" alignItems="center" gap={theme.spacing.md}>
        <Custom.IconButton
          size="small"
          sx={buttonSx}
          disabled={count === min}
          onClick={handleDecrement}
        >
          <RemoveRounded />
        </Custom.IconButton>

        <Custom.Typography>{count}</Custom.Typography>

        <Custom.IconButton size="small" onClick={handleIncrement} sx={buttonSx}>
          <AddRounded />
        </Custom.IconButton>
      </Stack>
    </Box>
  );
};
